import React from 'react'

function AlertPrecaucion( {aceptar,cerrar}) {
  return (
    <div className='w-50' style={{alignItems:'center' , margin:'auto'}}>
        <div class="alert alert-danger  alert-dismissible fade show ">
            <strong>Precaucion!</strong> Desea eliminar los elementos de la lista seleccionada?. &nbsp;&nbsp;

            <button type="button rounded" style={{borderRadius:'10px' , backgroundColor :'lightgrey'}} onClick={aceptar}>Aceptar</button>
            <button type="button" class="btn-close"
              onClick={cerrar} data-bs-dismiss="alert"></button>
        </div>
    </div>
  )
}

export default AlertPrecaucion